import type { TrolleyDrawer } from '@/hooks/useToolManagement/useGetTrolleys'

export function toDrawerOptions(drawers: TrolleyDrawer[]): ValueOption[] {
  return drawers.map(drawer => ({
    label: `${drawer.name} (${drawer.total_tools})`,
    value: drawer.id,
  }))
}
